import { HelpCircle, AlertTriangle, BookOpen, ShieldX, Compass, ArrowRight } from "lucide-react";

const cases = [
  {
    icon: Compass,
    text: "Vous souhaitez construire mais ne savez pas par où commencer.",
  },
  {
    icon: ShieldX,
    text: "Vous avez peur que votre permis soit refusé.",
  },
  {
    icon: BookOpen,
    text: "Vous ne comprenez pas les obligations techniques.",
  },
  {
    icon: AlertTriangle,
    text: "Vous voulez éviter les erreurs coûteuses.",
  },
  {
    icon: HelpCircle,
    text: "Vous cherchez un accompagnement fiable.",
  },
];

export default function VousEtesDansCeCas() {
  return (
    <section
      id="cas"
      data-testid="cas-section"
      className="py-24 md:py-32 bg-secondary border-y border-border"
    >
      <div className="container-wide">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: title */}
          <div className="lg:col-span-5 reveal lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-6">
              <span className="rule" />
              <span className="overline">Pour vous</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-medium leading-tight text-primary">
              Vous êtes{" "}
              <span className="italic font-light text-[hsl(var(--brand-terra))]">
                dans ce cas
              </span>{" "}
              ?
            </h2>
            <p className="mt-5 text-base text-muted-foreground leading-relaxed max-w-md">
              Un projet de construction à La Réunion soulève des questions
              techniques et administratives que peu de particuliers maîtrisent.
              Nous sommes là pour ça.
            </p>

            <a
              href="#contact"
              data-testid="cas-cta"
              className="mt-8 group inline-flex items-center gap-2 bg-[hsl(var(--brand-terra))] text-white px-7 py-4 text-sm font-medium tracking-wide rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:bg-[hsl(var(--brand-terra)/0.9)]"
            >
              Parlons de votre projet
              <ArrowRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>

          {/* Right: cases list */}
          <ul className="lg:col-span-7 space-y-3">
            {cases.map((c, i) => {
              const Icon = c.icon;
              return (
                <li
                  key={c.text}
                  data-testid={`cas-item-${i}`}
                  className="reveal group bg-white border border-border p-6 md:p-7 flex items-start gap-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-[hsl(var(--brand-terra))]"
                  style={{ transitionDelay: `${i * 60}ms` }}
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center bg-[hsl(var(--brand-terra)/0.08)] text-[hsl(var(--brand-terra))] rounded-2xl shrink-0">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <p className="text-base md:text-lg leading-snug text-primary font-medium pt-2">
                    {c.text}
                  </p>
                  <ArrowRight
                    size={18}
                    strokeWidth={1.4}
                    className="ml-auto mt-3 text-muted-foreground/30 transition-all duration-300 group-hover:text-[hsl(var(--brand-terra))] group-hover:translate-x-1 shrink-0"
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
